import React, { Component } from 'react';
import btn_submit from '../images/btn_submit.png';
import join_beta from '../images/join_beta.png';
import trophy_bottom from '../images/trophy_bottom.png';
import '../css/Footer.css';

class Header extends Component {

  render() {
    function submit() {
      var name = document.getElementsByName('name')[0].value;
      var email = document.getElementsByName('email')[0].value;
      window.sc.api("betasignup", {username:name,email:email}, success);
    }

    function success(data) {
      if (data.id !== undefined) {
        window.$('.thank-you').show();
        window.$('.name-taken').hide();
        window.$('.email-taken').hide();
        window.$('.success-modal').modal('toggle');
      }
      if (data.usertaken !== undefined) {
        window.$('.name-taken').show();
        window.$('.thank-you').hide();
        window.$('.email-taken').hide();
        window.$('.success-modal').modal('toggle');
      }
      if (data.emailexist !== undefined) {
        window.$('.email-taken').show();
        window.$('.thank-you').hide();
        window.$('.name-taken').hide();
        window.$('.success-modal').modal('toggle');
      }
    }
    
    return (
      <div className="App-footer">
        <div className="join-beta">
          <img src={join_beta} alt="Join beta" />
        </div>

        <div className="join-form">
          <form>
            <table width="100%">
              <tbody>
                <tr>
                  <td><strong>NAME:</strong></td>
                  <td><input name="name" type="text" required /></td>
                </tr>
              </tbody>
            </table>
            <table width="100%">
              <tbody>
                <tr>
                  <td><strong>EMAIL:</strong></td>
                  <td><input name="email" type="text" /></td>
                </tr>
              </tbody>
            </table>
            <table width="100%">
              <tbody>
                <tr>
                  <td colSpan="2"><img className="btn-submit" src={btn_submit} onClick={submit} alt="Submit" /></td>
                </tr>
              </tbody>
            </table>
          </form>
        </div>
        <div className="copyright">
          <p>For support or any suggestions contact us via our e-mail, Seth@<span className="orange">Snap</span>Challenge.com
          ©2016-2017 <span className="orange">Snap</span>Challenge, LLC.</p>
          <img src={trophy_bottom} alt="Trophy" />
        </div>
        <div className="modal fade success-modal">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
              </div>
              <div className="modal-body">
                <div className="thank-you">
                  <div className="glyphicon glyphicon-ok-circle"></div><div>Thank you!</div>
                </div>
                <div className="name-taken">
                  <div className="glyphicon glyphicon-exclamation-sign"></div><div>Name already taken!</div>
                </div>
                <div className="email-taken">
                  <div className="glyphicon glyphicon-exclamation-sign"></div>
                  <div>You are already registered for the beta, and will receive emails with announcements soon!</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Header;


// WEBPACK FOOTER //
// ./src/components/Footer.js